<template>
  <v-sheet outlined rounded="lg" class="pa-3 public-link" :class="{ 'public-link--inactive': !link.is_active }">
    <div class="d-flex align-start">
      <div class="flex-grow-1 min-width-0">
        <div class="font-weight-bold text-body-2 text-truncate" :title="title">
          {{ title }}
          <v-chip v-if="!link.is_active" x-small class="ml-1" color="#f0f0f0">Отключена</v-chip>
        </div>
        <div v-if="caption" class="text-caption grey--text text--darken-1 text-truncate">{{ caption }}</div>
        <div class="text-caption grey--text text-truncate" :title="url">{{ url }}</div>
      </div>
      <div class="d-flex align-center ml-2 flex-shrink-0">
        <v-btn icon small title="Скопировать ссылку" @click="$emit('copy', url)">
          <v-icon small>mdi-content-copy</v-icon>
        </v-btn>
        <template v-if="canManage">
          <v-btn icon small title="Изменить" @click="$emit('edit', { kind, link })">
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="link.is_active"
            icon
            small
            title="Отключить"
            @click="$emit('toggle-active', { kind, id: link.id, is_active: false })"
          >
            <v-icon small>mdi-link-off</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            small
            title="Включить"
            @click="$emit('toggle-active', { kind, id: link.id, is_active: true })"
          >
            <v-icon small>mdi-link-variant</v-icon>
          </v-btn>
        </template>
      </div>
    </div>

    <div v-if="showSelection" class="mt-2">
      <span v-if="!selectionItems.length" class="text-caption grey--text">{{ allLabel }}</span>
      <template v-else>
        <v-chip
          v-for="item in selectionItems"
          :key="item.id"
          x-small
          class="mr-1 mb-1 public-link__chip"
          :color="item.available ? '#ece9fb' : 'grey lighten-2'"
          :title="item.label"
        >
          <span class="text-truncate">
            {{ item.label }}<template v-if="!item.available">&nbsp;— недоступно</template>
          </span>
        </v-chip>
      </template>
    </div>
  </v-sheet>
</template>

<script>
import {
  linkTitle,
  expertLabel,
  serviceLabel,
  isServiceAvailable,
  isExpertAvailableForType,
} from './publicLinkLabels';

// Строка ограниченной ссылки на запись — в карточке эксперта и под типом услуги.
// Отключение подтверждает родитель (Calendar.vue), здесь только события.
export default {
  name: 'PublicLinkItem',
  props: {
    kind: { type: String, required: true }, // 'expert' | 'service'
    link: { type: Object, required: true },
    experts: { type: Array, default: () => [] },
    services: { type: Array, default: () => [] },
    serviceTypes: { type: Array, default: () => [] },
    canManage: { type: Boolean, default: false },
    showSelection: { type: Boolean, default: true },
    caption: { type: String, default: '' },
  },
  computed: {
    title() {
      return linkTitle(this.kind, this.link, this.experts, this.serviceTypes);
    },
    url() {
      const { href } = this.$router.resolve({ name: 'public-booking-link', params: { code: this.link.code } });
      return `${window.location.origin}${href}`;
    },
    allLabel() {
      return this.kind === 'expert' ? 'Все услуги эксперта' : 'Все эксперты, оказывающие услугу';
    },
    selectionItems() {
      const selection = (this.kind === 'expert' ? this.link.services : this.link.experts) || [];
      return selection.map((id) => (this.kind === 'expert'
        ? {
          id,
          label: serviceLabel(this.services, this.serviceTypes, id),
          available: isServiceAvailable(this.services, id),
        }
        : {
          id,
          label: expertLabel(this.experts, id),
          available: isExpertAvailableForType(this.experts, this.services, id, this.link.service_type),
        }));
    },
  },
};
</script>

<style lang="scss" scoped>
.public-link--inactive {
  opacity: 0.6;
}

.public-link__chip {
  max-width: 100%;

  ::v-deep .v-chip__content {
    min-width: 0;
    max-width: 100%;
  }
}

.min-width-0 {
  min-width: 0;
}
</style>
